import { TYPES } from "../types/types.constants";


export const setQrAction = (qr) => {

    return {
        type: TYPES.QR.SET_QR,
        payload: qr
    }
};

export const resetQrAction = () => {

    return {
        type: TYPES.QR.RESET_TRANSACTION_QR
    }
};